import React from 'react';
import RadioFieldGroup from 'components/shared/RadioFieldGroup';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';

const CanBeSkillsAdminNote = () => (
  <div className="EditRole-secondaryOptions">
    <ul className="EditRole-secondaryOptions--disabled">
      <li>
        {t(
          'settings.tab.roles.edit.skills_management_labels.can_admin_role_templates',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.skills_management_labels.can_admin_skills_library',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.skills_management_labels.can_admin_team_settings',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.skills_management_labels.can_admin_performance_metrics',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.skills_management_labels.can_manage_skills_admins',
        )}
      </li>
    </ul>
  </div>
);

const SkillsManagement = ({ disabled, selectedValue, onChange }) => (
  <div className="EditRole-section">
    <h3>{t('settings.tab.roles.edit.skills_management.title')}</h3>
    <div className="EditRole-sectionDescription">
      {t('settings.tab.roles.edit.skills_management.desc')}
    </div>
    <RadioFieldGroup
      name="skillsManagement"
      disabled={disabled}
      selectedValue={selectedValue}
      onChange={e => {
        onChange(e);
      }}
    >
      <RadioField value="no_access">
        {t('settings.tab.roles.edit.skills_management_labels.no_access')}
      </RadioField>
      <RadioField value="skills_admin">
        {t('settings.tab.roles.edit.skills_management_labels.skills_admin')}
      </RadioField>
      <CanBeSkillsAdminNote />
    </RadioFieldGroup>
  </div>
);

export default SkillsManagement;
